import Layout from '@/container/Full'
import WizardView from '@/views/wizard/WizardView'

const routes = [
  {
    path: '/quicklaunch',
    component: Layout,
    meta: {
      breadcrumb: 'Wizard',
      access_type: 'authorized',
    },
    children: [
      {
        path: '',
        name: 'quicklaunch',
        component: WizardView,
        meta: {
          access_type: 'authorized',
        }
      },
    ]
  },
]

export default routes
